import { useNavigate } from 'react-router-dom';

import type { BoardContextValue } from './useBoardContext';
import { useQltAuthStore } from '../stores/qlt';
import { saveRecentLecture, type RecentLecture } from './recent';

export function useEndPeriod(context: BoardContextValue): () => void {
  const navigate = useNavigate();
  return () => {
    if (context.unitId) {
      const entry: RecentLecture = {
        unitId: context.unitId,
        unitName: context.lessonTitle,
        courseId: context.courseId,
        classId: context.classId,
        classTitle: context.classTitle,
        subjectTitle: context.subjectTitle,
        subjectId: context.subjectId,
        gradeId: context.gradeId,
        // only valid for context.date - a reopen on another day must ask for a fresh note
        classNoteId: context.classNoteId,
        index: context.index,
        date: context.date,
        openedAt: new Date().toISOString(),
        teacherId: teacherIdOf(),
      };
      saveRecentLecture(entry);
    }
    navigate('/', { replace: true });
  };
}

function teacherIdOf(): string | undefined {
  const id = useQltAuthStore.getState().teacherId;
  return id === null || id === undefined ? undefined : String(id);
}
